import * as moment from "moment";

export class Monthpicker {
  public selectedYearMoment: moment.Moment;
  public selectedYearText: string;
  public selectedMonthMoment: moment.Moment;
  public selectedMonthIndex: number;
  public selectedMonthYear: number;
  public months: Array<string> = [];

  constructor() {
    this.selectedYearMoment = moment();
    this.updateYearText();

    this.selectedMonthMoment = moment();

    this.months = moment.months();

    this.selectedMonthIndex = this.selectedMonthMoment.month();
    this.selectedMonthYear = this.selectedYearMoment.year();
  }

  /**
   * Update year text
   */
  updateYearText() {
    this.selectedYearText = moment(this.selectedYearMoment).format("YYYY");
  }

  /**
   * Select month
   * @param index
   */
  selectMonth(index: number) {
    this.selectedMonthMoment = moment().month(index);
    this.selectedMonthIndex = this.selectedMonthMoment.month();
    this.selectedMonthYear = this.selectedYearMoment.year();
  }

  /**
   * Increment year
   */
  incrementYear() {
    this.selectedYearMoment = this.selectedYearMoment.add(1, "year");
    this.updateYearText();
  }

  /**
   * Decrement year
   */
  decrementYear() {
    this.selectedYearMoment = this.selectedYearMoment.subtract(1, "year");
    this.updateYearText();
  }
}
